<template>
  <div
    ref="menu"
    v-if="! $store.getters['settingsModule/elementSidebar']"
    :class="positionClasses"
    class="wf--ml-48 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border-4 wf-border-white wf-shadow-md wf-w-56 wf-z-50"
  >
    <ul>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="content"
        title="Content"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in contentProperties"
            :key="property.key"
            :is="property.component"
            :text="property.text"
            :property="property.property"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="bannerStyles"
        title="Banner Styles"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in styleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :propertyTriggers="property.mutations"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        v-if="parent.hasIcon"
        @updateOpen="updateOpen"
        trigger="iconStyles"
        title="Icon Styles"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in iconStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        v-if="parent.hasCTA"
        @updateOpen="updateOpen"
        trigger="ctaStyles"
        title="CTA Styles"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in ctaStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="advanced"
        title="Advanced"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in advancedProperties"
            :key="property.key"
            :is="property.component"
            :element="element"
          ></component>
        </template>
      </EditorElementMenuList>
    </ul>
  </div>
</template>

<script>
  import ContentText from '../../MenuProperties/ContentText'
  import ElementMenu from '../../contracts/ElementMenu'
  export default ElementMenu.extend({
    components: {
      ContentText
    },
    data() {
      return {
        open: 'content',
      }
    },
    computed: {
      contentProperties() {
        let contentProperties = [
          {key: 'has-icon', component:'ContentToggle', text:'has an Icon', property:'hasIcon'},
        ]
        if(this.parent.hasIcon) {
          contentProperties.push({key: 'icon-content', component:'ContentIcon'})
        }
        contentProperties.push({key: 'has-cta', component:'ContentToggle', text:'has a CTA', property:'hasCTA'})
        if(this.parent.hasCTA) {
          contentProperties.push({key: 'link-content', component:'ContentText', text:'CTA Text', property:'ctaText'},{key: 'text-content', component:'ContentText', text:'CTA link', property:'ctaLink'})
        }
        contentProperties.push({key: 'is-closable', component:'ContentToggle', text:'is closable', property:'isClosable'})
        return contentProperties
      },
      mutationTriggers() {
        return {
          'banner-position': {
            'TOP': [
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Rounded", value: 'ROUNDED_NONE', touched: false}
                ],
                array: 'classes',
              },
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Shadow", value: 'SHADOW_NONE', touched: false}
                ],
                array: 'classes',
              }
            ],
            'BOTTOM': [
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Rounded", value: 'ROUNDED_NONE', touched: false}
                ],
                array: 'classes',
              },
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Shadow", value: 'SHADOW_NONE', touched: false}
                ],
                array: 'classes',
              }
            ],
            'FLOAT_BOTTOM': [
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Shadow", value: 'SHADOW_MD', touched: false},
                  {property: "Rounded", value: 'ROUNDED_MD', touched: false},
                ],
                array: 'classes',
              },
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Shadow", value: 'SHADOW_NONE', touched: false}
                ],
                array: 'classes',
              }
            ],
          }
        }
      },
      styleProperties() {
        let styles = []
        Object.keys(this.mutationTriggers).forEach(trigger => {
          let style = this.parent.properties.styles.find(style => style.key == trigger)
          if (! style) {
            return
          }
          styles.push({...style, mutations: this.mutationTriggers[trigger]})
        })
        return styles
      },
      iconStyleProperties() {
        return this.parent.properties.iconStyles
      },
      ctaStyleProperties() {
        return this.parent.properties.ctaStyles
      },
      advancedProperties() {
        return this.parent.properties.advanced
      },
    },
  })
</script>